import { toast } from 'sonner';
import { API_ENDPOINTS, HTTP_METHODS } from '../config/api';
import { BaseApiService, ApiResponse } from './baseApi';

// Material Planning DTO interface
export interface MaterialPlanningDto {
  planningYear: number;
  planningMonth: number;
  planningMonthDate: string;
  rawItemId: number;
  rawItemName: string;
  rawItemSku: string;
  rawItemCategoryId: number;
  rawItemCategoryName: string;
  endgoodId: number;
  endgoodName: string;
  endgoodSku: string;
  salesOrderId: number;
  salesOrderNumber: string;
  customerName: string;
  branchId: number;
  branchName: string;
  endgoodRequiredQty: number;
  endgoodWipQty: number;
  endgoodPackedQty: number;
  endgoodInvoicedQty: number;
  endgoodNetRequiredQty: number;
  requiredQuantity: number;
  currentInventory: number;
  projectedConsumption: number;
  supplierDelivery: number;
  netRequirement: number;
  outOfStockFlag: number;
  salesOrderCount: number;
}

// Material Planning API Service
class MaterialPlanningApiService extends BaseApiService {
  
  // Get material planning report by raw item ID
  async getMaterialPlanningByRawItem(
    rawItemId: number,
    branchId?: number,
    year?: number,
    month?: number
  ): Promise<ApiResponse<MaterialPlanningDto[]>> {
    try {
      const response = await this.makeRequest<ApiResponse<MaterialPlanningDto[]>>(
        API_ENDPOINTS.MATERIAL_PLANNING.BY_RAW_ITEM(rawItemId, branchId, year, month),
        { method: HTTP_METHODS.GET }
      );
      
      return response;
    } catch (error) {
      // console.error('MaterialPlanningApiService: Error fetching material planning data:', error);
      toast.error('Failed to fetch material planning data');
      throw error;
    }
  }

  // Get all material planning data for a branch/year/month
  async getAllMaterialPlanning(
    branchId?: number,
    year?: number,
    month?: number
  ): Promise<ApiResponse<MaterialPlanningDto[]>> {
    try {
      const response = await this.makeRequest<ApiResponse<MaterialPlanningDto[]>>(
        API_ENDPOINTS.MATERIAL_PLANNING.ALL(branchId, year, month),
        { method: HTTP_METHODS.GET }
      );
      
      return response;
    } catch (error) {
      // console.error('MaterialPlanningApiService: Error fetching all material planning data:', error);
      toast.error('Failed to fetch material planning data');
      throw error;
    }
  }
}

export const materialPlanningApiService = new MaterialPlanningApiService();

